/**
 * Einheitliche, laienverständliche Beschriftung des Kampagnen-Status
 * (nicht zu verwechseln mit dem Status je EMPFÄNGER, siehe
 * RecipientStatusBadgeTableCell). Wird von Index.jsx, SendControlPanel.jsx
 * und Recipients.jsx gemeinsam genutzt, damit der Wortlaut überall exakt
 * gleich ist.
 */
export const CAMPAIGN_STATUS_LABELS = {
    draft: {label: "Entwurf (noch nicht scharf geschaltet)", variant: "secondary"},
    scheduled: {label: "Scharf geschaltet – wartet auf das Versandfenster", variant: "info"},
    sending: {label: "Versand läuft", variant: "primary"},
    paused: {label: "Pausiert", variant: "warning"},
    completed: {label: "Abgeschlossen", variant: "success"},
    canceled: {label: "Abgebrochen", variant: "danger"},
};

export function campaignStatusLabel(status) {
    return CAMPAIGN_STATUS_LABELS[status]?.label ?? status ?? "-";
}

export function campaignStatusVariant(status) {
    return CAMPAIGN_STATUS_LABELS[status]?.variant ?? "light";
}
